export function isExcludedClarityRuntime(): boolean {
  if (typeof window === 'undefined') return true;
  const hostname = window.location.hostname;
  if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1') return true;
  // Headless browsers used by e2e/automated test runners (Playwright, Cypress, Selenium) set this flag.
  if (typeof navigator !== 'undefined' && navigator.webdriver) return true;
  return false;
}

export function clearFirstPartyClarityCookies(): void {
  if (typeof document === 'undefined') return;
  for (const name of ['_clck', '_clsk']) {
    document.cookie = `${name}=; Max-Age=0; path=/`;
  }
}
